import { Box, CircularProgress } from '@mui/material';

import { FProgressBar } from '../../../../../../components/base';
import { GeneralInformationFields } from './components';
import { useQuestionnaireFormik } from '../../../../common/hooks';
import { intakeQuestionnaireActions } from '../../../../../../store';
import { INTAKE_TAB_IDS } from '../../../constants';
import { useIntakeGeneralInfoUpdateLoading, useIntakeQuestionnaireLoading } from '../../../hooks';
import { useIntakeGeneralInfoInitialValues, useSaveIntakeGeneralInfoFieldOnBlur } from './hooks';
import { GENERAL_INFORMATION_FORM_LOADING_OVERLAY_SX, GENERAL_INFORMATION_FORM_SX } from './styles';
import { GENERAL_INFO_FORM_SCHEMA } from './validationSchema';
import { QuestionnaireSectionLabel } from '../../../../common';
import { FORTA_BLUE } from '../../../../../../utils/colors';

export default function GeneralInformationForm() {
  const initialValues = useIntakeGeneralInfoInitialValues();
  const isLoading = useIntakeQuestionnaireLoading();
  const isUpdating = useIntakeGeneralInfoUpdateLoading();
  const formik = useQuestionnaireFormik({
    tabId: INTAKE_TAB_IDS.GENERAL,
    initialValues,
    validationSchema: GENERAL_INFO_FORM_SCHEMA,
    updateTabStatus: intakeQuestionnaireActions.updateIntakeTabStatus,
  });
  const saveFieldOnBlur = useSaveIntakeGeneralInfoFieldOnBlur(formik, initialValues);

  return (
    <>
      <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
        General information
      </QuestionnaireSectionLabel>
      <Box
        component="form"
        noValidate
        onSubmit={formik.handleSubmit}
        sx={GENERAL_INFORMATION_FORM_SX}
      >
        {isUpdating ? <FProgressBar /> : null}
        {isLoading ? (
          <Box sx={GENERAL_INFORMATION_FORM_LOADING_OVERLAY_SX}>
            <CircularProgress size={32} />
          </Box>
        ) : null}
        <GeneralInformationFields
          disabled={isLoading}
          formik={formik}
          saveFieldOnBlur={saveFieldOnBlur}
        />
      </Box>
    </>
  );
}
